// Auto-generated by scripts/generate-registry.mjs from packages/modules/rattan_oval_tumbler_type_b/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const rattan_oval_tumbler_type_b: ModuleSchema = {
  "id": "rattan_oval_tumbler_type_b",
  "uniqueId": "B3D_OVT9K",
  "createdAt": "2026-10-28T22:44:03.822Z",
  "updatedAt": "2026-10-28T22:44:03.823Z",
  "label": "Rattan Oval Tumbler",
  "description": "Type B rattan tumbler with an oval (rounded rectangle) plan, closed floor, open mouth, load-bearing wall and continuous wave-strand relief fused into one union body.",
  "category": "rattan",
  "tags": [
    "rattan-oval-tumbler-type-b"
  ],
  "sliders": [
    {
      "key": "outerWidth",
      "label": "Outer Width",
      "min": 48,
      "max": 90,
      "default": 64,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "outerDepth",
      "label": "Outer Depth",
      "min": 34,
      "max": 70,
      "default": 46,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "cornerRadius",
      "label": "Corner Radius",
      "min": 4,
      "max": 22,
      "default": 17,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "height",
      "label": "Wall Height",
      "min": 60.8,
      "max": 97,
      "default": 78,
      "step": 1.9,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "union_body",
      "label": "Wall + Continuous Backing + Wave Rows",
      "default": "#9a633d",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "tumbler_body",
      "label": "Rattan Oval Tumbler",
      "name": "Rattan Oval Tumbler",
      "color": "#9a633d",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "union_body",
          "label": "Wall + Continuous Backing + Wave Rows",
          "name": "Wall + Continuous Backing + Wave Rows",
          "groupId": 0,
          "colorKey": "union_body",
          "defaultColor": "#9a633d",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Union Body"
    }
  ]
};
